import {Directive, inject, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DotRouteService} from '@ng-dot/route';
import {BehaviorSubject, Subject, tap} from 'rxjs';
import {SelfControlService} from '../services/self-control.service';
import {MainComponentBase} from './main-component-base';

@Directive()
/**
 * SelfControlService 와 연동되는 **단일** RUD 조작 컴포넌트 기반
 *
 * @see SelfControlService
 * @see MainComponentBase
 * @see PageMagicComponent
 */
export abstract class SingleControlComponentBase<TModel>
	extends MainComponentBase<TModel>
	implements OnInit {

	/**
	 * 부모 컴포넌트를 설정하여 연동 처리 합니다.
	 * - 부모가 대화상자일 경우
	 */
	@Input() parent: any;

	@ViewChild('_updateLink_', {static: false}) _updateLink_!: TemplateRef<any>;
	@ViewChild('_deleteLink_', {static: false}) _deleteLink_!: TemplateRef<any>;

	protected _control = inject(SelfControlService);
	protected _route   = inject(DotRouteService);

	protected _selfAfterDeleted = this._controlAfterDeleted.bind(this);
	protected _selfAfterUpdated = this._controlAfterUpdated.bind(this);

	/**
	 * 출력 항목
	 * @protected
	 */
	protected _item: TModel;

	/**
	 * 출력 항목
	 */
	item$: Subject<TModel> | BehaviorSubject<TModel> = new BehaviorSubject(null);

	constructor(feature?: string) {
		super(feature);
	}

	ngOnInit() {
		this.item$
			.pipe(this._takeUntilDestroy)
			.subscribe((item: TModel) => {
				this._item = item;
			});
	}

	#controlGetItem() {
		const {_item} = this;
		if (!_item) {
			throw new TypeError('$item 이 할당되지 않았습니다.');
		}
		return _item;
	}


	/**
	 * 수정 성공 후 실행
	 * @param response
	 * @protected
	 */
	protected _controlAfterUpdated(response: TModel) {
		this.item$.next(response);
	}

	/**
	 * 삭제 성공 후 실행
	 * @protected
	 */
	protected _controlAfterDeleted() {
	}

	/**
	 * 삭제
	 */
	update$() {
		return this._control.update$(this.#controlGetItem())
			.pipe(tap(this._selfAfterUpdated));
	}

	/**
	 * 삭제
	 */
	delete$() {
		return this._control.delete$(this.#controlGetItem() as any)
			.pipe(tap(this._selfAfterDeleted));
	}

	/**
	 * 수정
	 */
	update() {
		this.update$().subscribe();
	}

	/**
	 * 삭제
	 */
	delete() {
		this.delete$().subscribe(() => {
			const {parent} = this;
			if (parent && parent['modalRef']) {
				parent['modalRef']?.close()
			}
		});
	}
}
